"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
function protobufferToPascalCase(input) {
    var originalNames = ['HighGrowth', 'Growth', 'Balanced', 'Moderate', 'UserDefinedAllocation', 'Gfc', 'TechBubble', 'RpHighGrowth',
        'RpGrowth', 'RpBalanced', 'RpModerate', 'Long15YearHistory', 'GlobalFinancialCrisis', 'BullMarket', 'BearAndRebound', 'FullHistory'];
    var reverseUppercaseMap = originalNames.reduce(function (acc, og) {
        var newEntry = {};
        newEntry[og.toUpperCase()] = og;
        return __assign(__assign({}, acc), newEntry);
    }, {});
    var pascal = input ? reverseUppercaseMap[input] : input;
    return pascal;
}
exports.protobufferToPascalCase = protobufferToPascalCase;
//# sourceMappingURL=ProtobufferPascalMap.js.map